(() => {
"use strict";
const config = document.getElementById("superior-wishlist-config");
const dialog = document.getElementById("superior-wishlist-signin");
if (!config || !dialog) return;
const c = config.dataset;
const signedIn = c.signedIn === "true";
const selector = "button.wysh-product-button, button.wysh-button";
let previousFocus = null;
window.addEventListener("click", event => {
 const target = event.target instanceof Element ? event.target.closest(selector) : null;
 if (!target || signedIn) return;
 event.preventDefault();
 event.stopImmediatePropagation();
 previousFocus = target;
 if (!dialog.open) dialog.showModal();
}, true);
dialog.querySelector("[data-superior-wishlist-close]").addEventListener("click", () => dialog.close());
dialog.addEventListener("close", () => previousFocus?.focus());
function labelButton(button) {
 const saved = button.classList.contains("added");
 const label = saved ? c.saved : c.add;
 const span = button.querySelector(".wysh-text");
 if (span) {
  if (span.dataset.removeText !== c.saved) span.dataset.removeText = c.saved;
  if (span.dataset.addText !== c.add) span.dataset.addText = c.add;
  if (span.textContent !== label) span.textContent = label;
 }
 if (button.getAttribute("aria-label") !== label) button.setAttribute("aria-label", label);
 if (button.getAttribute("aria-pressed") !== String(saved)) button.setAttribute("aria-pressed", String(saved));
}
function addSharing(button) {
 const value = button.dataset.shareUrl;
 if (!value) return;
 let url;
 try { url = new URL(value, location.origin); } catch { return; }
 if (url.origin !== location.origin || !url.pathname.startsWith("/a/wysh/shared/")) return;
 let row = button.nextElementSibling;
 if (!row?.classList.contains("superior-wishlist-sharing")) {
  row = document.createElement("div");
  row.className = "superior-wishlist-sharing";
  const email = document.createElement("a");
  email.textContent = c.email;
  const copy = document.createElement("button");
  copy.type = "button";
  copy.textContent = c.copy;
  copy.addEventListener("click", async () => {
   const current = row.dataset.shareUrl;
   try {
    await navigator.clipboard.writeText(current);
    copy.textContent = c.copied;
    setTimeout(() => { copy.textContent = c.copy; }, 2500);
   } catch { window.prompt(c.copyFailed, current); }
  });
  const help = document.createElement("small");
  help.textContent = c.emailHelp;
  row.append(email, copy, help);
  button.insertAdjacentElement("afterend", row);
 }
 row.dataset.shareUrl = url.href;
 row.querySelector("a").href = "mailto:?subject=" + encodeURIComponent(c.subject) + "&body=" + encodeURIComponent(c.emailIntro + "\n\n" + url.href);
 if (!signedIn && !button.parentElement.querySelector(".superior-wishlist-notice")) {
  const notice = document.createElement("div");
  notice.className = "superior-wishlist-notice";
  const text = document.createElement("p");
  text.textContent = c.notice;
  const link = document.createElement("a");
  link.href = c.loginUrl;
  link.textContent = c.login;
  notice.append(text, link);
  button.insertAdjacentElement("beforebegin", notice);
 }
}
function updateWithin(root) {
 if (!(root instanceof Element)) return;
 if (root.matches(selector)) labelButton(root);
 root.querySelectorAll(selector).forEach(labelButton);
 if (root.matches(".wysh-share-button")) addSharing(root);
 root.querySelectorAll(".wysh-share-button").forEach(addSharing);
}
updateWithin(document.body);
new MutationObserver(records => {
 for (const record of records) {
  if (record.type === "attributes") {
   if (record.target.matches(selector)) labelButton(record.target);
   if (record.target.matches(".wysh-share-button")) addSharing(record.target);
  } else {
   record.addedNodes.forEach(node => updateWithin(node));
  }
 }
}).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:["class","data-share-url"]});
})();